import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomizedAvailabilityFormComponent } from './customized-availability-form.component';
import { AngularMaterialModule } from '../../angular-material/angular-material.module';
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { PipesModule } from "../../pipes/index";



@NgModule({
  declarations: [CustomizedAvailabilityFormComponent],
  imports: [
    CommonModule,
    AngularMaterialModule,
    FormsModule, ReactiveFormsModule,
    PipesModule
  ],
  exports:[CustomizedAvailabilityFormComponent]
})
export class CustomizedAvailabilityFormModule { }
